export default "__VITE_ASSET__BXaAltWP__"